import { StyledTimeLeft } from './TimeLeft.styled';
import { motion } from 'framer-motion';

export default function TimeLeft({ secondsLeft }) {
  return secondsLeft == null ? null : (
    <StyledTimeLeft>
      <motion.div
        style={{
          ...getRandomTransformOrigin(),
        }}
        variants={variants}
        animate={secondsLeft < 6 ? 'shake' : 'rest'}
      >
        <span className="time-left">{secondsLeft}&Prime;</span>
      </motion.div>
    </StyledTimeLeft>
  );
}

const getRandomTransformOrigin = () => {
  const value = (200 + 10 * Math.random()) / 100;
  const value2 = (200 + 16 * Math.random()) / 100;
  return {
    originX: value,
    originY: value2,
  };
};

const variants = {
  shake: (i) => ({
    rotate: i % 2 === 0 ? [-2, 3.3, 0] : [3, -3.4, 0],
    transition: {
      repeat: Infinity,
      duration: 0.3,
    },
  }),
  rest: {
    rotate: 0,
  },
};
